/**
 * Updates given partial item with given id in items, if match found. If not found, returns old items,
 * i.e. received update on item we don't have
 * @param idKey
 * @param items
 * @param item
 */
export const updateItem = <
  TData extends Record<TIdKey, any>,
  TIdKey extends keyof TData = keyof TData
>(
  idKey: TIdKey,
  items: TData[],
  item: Partial<TData>,
  itemId: TData[TIdKey],
): TData[] => {
  const idx = items.findIndex(d => d[idKey] === itemId);

  // Update existing
  if (idx >= 0) {
    const newItems = [...items];
    newItems[idx] = {...newItems[idx], ...item};
    return newItems;
  }

  return items;
};
